module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"kuno.ist","short_name":"kuno.ist","start_url":"/","background_color":"#080808","theme_color":"#080808","display":"minimal-ui","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8d751d7425e82b8b0ee047ca3cc7a024"},
    }]
